import { Bubble } from '../types';
import { Hex } from 'js/bubbleCore/Hex';
import { IGameData, IHexGridData, Place } from 'js/bubbleCore/types';
import { removeItem } from 'js/framework/utils/array-utils';
import { spacePositionToGridHex } from 'js/bubbleCore/utils/spacePositionToGridHex';
import { isInGrid } from 'js/bubbleCore/utils/isInGrid';
import { isSpaceFree } from 'js/bubbleCore/utils/isSpaceFree';
import { getNeighboursHexes } from 'js/bubbleCore/utils/getNeighboursHexes';
import { setGridValue } from 'js/bubbleCore/utils/setGridValue';
import { transferBubble } from 'js/bubbleCore/handlers/transferBubble';
import { IEvent, createBubbleUpdatedEvent } from 'js/bubbleCore/events';

export function putBubbleToGrid(
  data: IGameData,
  bubble: Bubble,
  colliders: Bubble[],
  events: IEvent[],
): void {
  const availableSpace = findAvailableSpace(data.grid, bubble, colliders);

  if (!availableSpace) {
    throw new Error(`no availableSpace`);
  }

  bubble.col = availableSpace.offsetPosition.x;
  bubble.row = availableSpace.offsetPosition.y;

  events.push(createBubbleUpdatedEvent(bubble));
  transferBubble(bubble, data, Place.Grid, events);
}

export function findAvailableSpace(
  grid: IHexGridData<Bubble>,
  bubble: Bubble,
  colliders: Bubble[],
): Hex | undefined {
  const originPosition = spacePositionToGridHex(
    bubble.hexSpaceX - bubble.velX,
    bubble.hexSpaceY - bubble.velY,
    grid,
  );

  const collision = colliders[0];
  const collisionHex = new Hex(grid.type).setOffset(collision.col, collision.row);

  return getNeighboursHexes(grid, collisionHex)
    .filter((hex) => {
      const {x, y} = hex.offsetPosition;
      return isInGrid(grid, x, y) && isSpaceFree(grid, x, y);
    })
    .sort((a, b) => originPosition.distanceTo(a) - originPosition.distanceTo(b))[0];
}